import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { ExternalOt, UpdateExternalOt } from "./external-ot.interface";
import {
  SearchExternalOtsWithMaterialsParams,
  SearchExternalOtsWithMaterialsResponse,
} from "./external-ot-search-with-materials.interface";

export const externalOtApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExternalOt: builder.query<APIResponse<ExternalOt[]>, void>({
      query: () => ({ url: "auth/works-orders/external-ot" }),
      providesTags: ["ExternalOt"],
    }),

    searchExternalOt: builder.query<APIResponse<ExternalOt[]>, string>({
      query: (search) => ({
        url: "auth/works-orders/external-ot/search",
        params: { search },
      }),
      providesTags: ["ExternalOt"],
    }),

    searchExternalOtsWithMaterials: builder.query<
      SearchExternalOtsWithMaterialsResponse,
      SearchExternalOtsWithMaterialsParams
    >({
      query: (params) => ({
        url: "auth/works-orders/external-ot/search",
        params,
      }),
      providesTags: ["ExternalOt"],
    }),

    getExternalOtById: builder.query<APIResponse<ExternalOt>, number>({
      query: (id) => ({ url: `auth/works-orders/external-ot/${id}` }),
      providesTags: (_result, _error, id) => [{ type: "ExternalOt", id }],
    }),

    updateExternalOt: builder.mutation<APIResponse<ExternalOt>, { id: number; changes: UpdateExternalOt }>({
      query: ({ id, changes }) => ({
        url: `auth/works-orders/external-ot/${id}`,
        method: "PATCH",
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "ExternalOt", id }, "ExternalOt"],
    }),
  }),
});

export const {
  useGetExternalOtQuery,
  useLazyGetExternalOtQuery,
  useSearchExternalOtQuery,
  useLazySearchExternalOtQuery,
  useSearchExternalOtsWithMaterialsQuery,
  useLazySearchExternalOtsWithMaterialsQuery,
  useGetExternalOtByIdQuery,
  useLazyGetExternalOtByIdQuery,
  useUpdateExternalOtMutation,
} = externalOtApi;
